import { render, staticRenderFns } from "./ACompanies.vue?vue&type=template&id=5d2b9b03&scoped=true"
import script from "./ACompanies.vue?vue&type=script&lang=js"
export * from "./ACompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b9b03",
  null
  
)

export default component.exports